import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { OrdersModule } from '../orders/orders.module';
import { ProductsModule } from '../products/products.module';
import { ReviewsController } from './reviews.controller';
import { PrismaReviewsRepository, ReviewsRepository } from './reviews.repository';
import { ReviewsService } from './reviews.service';

@Module({
  imports: [AuthModule, ProductsModule, OrdersModule],
  controllers: [ReviewsController],
  providers: [
    ReviewsService,
    PrismaService,
    {
      provide: ReviewsRepository,
      useClass: PrismaReviewsRepository,
    },
  ],
})
export class ReviewsModule {}
